import comp from "./GPTVision";
export default comp;
